module.exports = __webpack_public_path__ + "img/alba-majuscules.654a4f48.jpg";